export default "__VITE_ASSET__DtDI5Q5X__"